import getAlbumByToken from '../apis/api';
import Utils from '../utility/utils';
import { processSingleAlbumInfoByTokenResponse } from '../translators/share_data_translator';
import Omniture from './omniture';

const getStoreObject =() =>{
    return window.store;
}
const redirectTo = (redirect_url) =>{
    debugger;
    try {
        // Validate and sanitize the redirect URL
        const sanitizedUrl = new URL(redirect_url, window.location);

        // Ensure the redirection is to the same origin
        if (sanitizedUrl.origin === window.location.origin) {
            window.location.href = sanitizedUrl.href;
        } else {
            console.error('Redirection to an untrusted origin is blocked.');
        }
    } catch (error) {
        console.error('Invalid redirect URL provided:', error);
    }
}

const redirectToLibraryAsLoggedIn = (response, store, isShared) =>{
    const url_params={}
    url_params.pgvw = photoOrg.constants.SHARED_WITH_ME_SINGLE_ALBUM_VIEW
    url_params.aid = response.entities[0].id;
    url_params.oid = response.entities[0].ownerAccountId;
    url_params.dc = response.entities[0].dataCenter;
    url_params.pf = 'ps'; // pf : page from -- ps: public share
    var ovrUrlParam = photoOrg.Util.getURLParameter("ovr",null,true);
    // Check for the ovr=google_lgn/google_reg param in the url and based on that delete the defaultPageView
    if(ovrUrlParam === "google_lgn"){
        var jStorageObj = JSON.parse(localStorage.getItem('jStorage'));
        delete(jStorageObj[store.acctId + "_defaultPageView"]);
        localStorage.setItem('jStorage',JSON.stringify(jStorageObj));
    }
    try{
        if(store && store.acctId === String(response.entities[0].ownerAccountId)){
            url_params.pgvw = photoOrg.constants.SINGLE_ALBUM_VIEW
            if(isShared){
                url_params.isShared = true
            }
        }
    }catch(e){
        console.error(e);
    }
    const url = "?" + photoOrg.Util.sanitizeUrl(window.location.href.split('?')[1]);
    const modifiedUrl = `${photoOrg.config.photos_url}/pgvw/${url_params.pgvw}/aid/${url_params.aid}/oid/${url_params.oid}/dc/${url_params.dc}/pf/${url_params.pf}${url}`;

    console.log("in processSingleAlbumInfoByTokenResponse...auth cookies exist, so redirecting to library page");
    redirectTo(modifiedUrl);
}

const handleToken = (setProcessedData, uniqPubShareID) => {    
    try{
        const token = Utils.getTokenFromURL();
        if (token && token != "null") { 
            
            const promise = getAlbumByToken(token,uniqPubShareID);
            promise.then((response) =>{
                console.log("response in handle token", response);  
                var store = getStoreObject();
                const formattedResponseData = processSingleAlbumInfoByTokenResponse(response);
                if(typeof (store) !== "undefined" && store.isUserLoggedIn && store.isUserLoggedIn === "true"){
                    redirectToLibraryAsLoggedIn(response,store,formattedResponseData.isShared);
                    return;
                }             
                setProcessedData(formattedResponseData);
                Omniture(response);
            })
        }else{
            console.log("No token found so redirecting to store error page")
            var errorId=""
            var error_message= "error_id="+errorId+"&error_message="+photoOrg.translations.photos["Error"]["invalid_token"]+"&error_service=library&error_code=&error_noodle="+this.noodle+"&error_from_url="+this.url+"&error_from_popup=false";
            photoOrg.Util.redirectToStoreErrorPage(error_message)
        }
    }catch(error){
        photoOrg.clientLogger.error({description: "LIBRARY:handleToken::Exception", errorCode: "LIBRARY:PUBLIC_SHARE_LANDING_PAGE", err_desc: error.message, err_stack: error.stack});
    }       
    
    return null;
}

export default handleToken;